import React, { ChangeEvent } from 'react'
import classNames from 'classnames'
import { Form } from 'react-bootstrap'
import { WidgetProps } from '@rjsf/utils'

import './../formFills.scss'
import { CustomWidgetProps } from '../FormCitation/FormCitation'

export const CustomCheckboxWidget: React.FC<WidgetProps> = (props) => {
  const { value, onChange, disabled } = props
  const { isEditing, fieldContainerClass, citationButton } = props.options as CustomWidgetProps
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked)
  }

  return isEditing || value !== null ? (
    <div className={fieldContainerClass}>
      <Form.Check
        className={classNames('d-flex contact-information-checkbox form-control', {
          'disabled-contact-information-field border-0': disabled,
        })}
        type='checkbox'
        checked={value}
        onChange={handleChange}
        disabled={disabled}
      />
      {!isEditing && value ? citationButton : null}
    </div>
  ) : (
    <Form.Control
      type='text'
      placeholder='No relevant information detected'
      className='form-control border-0 disabled-contact-information-field'
      disabled={true}
    />
  )
}
